import axios, { AxiosPromise } from 'axios';

import { ITrip } from '../../../@types/model/dispatch/trip';
import { ITripRelatedData } from '../../../@types/model/dispatch/tripRelatedData';
import qs from 'qs';

export default class TripHttpService {
    public static getTripData() : AxiosPromise<Array<ITrip>> {
        return axios.get(`${API_URL}/v1/Trip`);
    }

    public static getAvailableTrips(fromDateUnix ?: number, toDateUnix ?: number) : AxiosPromise<Array<ITrip>> {
        return axios.get(`${API_URL}/v1/Trip/GetAvailableTrips`, {
            params: {
                fromDateUnix,
                toDateUnix,
            },
        });
    }

    public static getTrip(id : number) : AxiosPromise<ITrip> {
        return axios.get(`${API_URL}/v1/Trip/GetTrip`, {
            params: {
                id,
            },
        });
    }

    public static addOrUpdateTrip(data : ITrip) : AxiosPromise<ITrip> {
        return axios.post(`${API_URL}/v1/Trip/PostTrip`, data);
    }

    public static getTripTransactionData(fromDateUnix ?: number, toDateUnix ?: number, organizationIds ?: Array<number>, siteIds ?: Array<number>, loadMasterData ?: boolean) : AxiosPromise<ITripRelatedData> {
        return axios.get(`${API_URL}/v1/Trip/Transaction`, {
            params: {
                fromDateUnix,
                toDateUnix,
                organizationIds,
                siteIds,
                loadMasterData,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static tripDelete = (tripId : number, deleteReason : string) : AxiosPromise<ITrip> => {
        return axios.delete(`${API_URL}/v1/Trip/Delete`, {
            params : { tripId, deleteReason },
        });
    };
}
